<template src="./template.html" />

<script>

export default {
  name: 'top'
}
</script>

<style src="./style.scss" lang="scss" scoped/>
